"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const environment_1 = require("./environments/environment");
class DEBUG {
    static open(file) {
        if (!DEBUG.checked) {
            DEBUG.checked = true;
            if (environment_1.environment.production) {
                DEBUG.show = false;
            }
        }
        if (!DEBUG.show) {
            return;
        }
        console.log('%c ' + file + ' ', 'color:white;background-color:gray;');
    }
    static log(file, what = null, objs = null) {
        if (!DEBUG.show) {
            return;
        }
        if (!what) {
            console.log('%c ' + file + ' %c CONSTRUCTOR ', 'color:white;background-color:black;', 'color:white;background-color:orange;');
            if (!DEBUG.constructs[file]) {
                DEBUG.constructs[file] = true;
            }
            else {
                console.log('%c ' + file + ' %c CONSTRUCTOR %c ALREADY CONSTRUCTED?', 'color:white;background-color:black;', 'color:white;background-color:orange;', 'color:white;background-color:red;');
            }
        }
        else {
            if (!objs) {
                console.log('%c ' + file + ' %c ' + what + ' ', 'color:white;background-color:black;', 'color:white;background-color:blue;');
            }
            else {
                console.log('%c ' + file + ' %c ' + what + ' ', 'color:white;background-color:black;', 'color:white;background-color:blue;', objs);
            }
        }
    }
}
DEBUG.show = false;
DEBUG.checked = false;
DEBUG.constructs = {};
exports.DEBUG = DEBUG;
